// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__neNF7","modalBody":"MealsPop_modalBody__dXbJ8"};